import SimilarDeals from './SimilarDeals';
export default SimilarDeals;